import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// auth
import { GuestGuard, OtpGuard } from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';

// ----------------------------------------------------------------------

// LOGIN
const LoginPage = lazy(() => import('src/pages/auth/login'));
const AuthPhonePage = lazy(() => import('src/pages/auth/auth-phone'));
const RegisterPage = lazy(() => import('src/pages/auth/register'));
const VerifyPage = lazy(() => import('src/pages/auth/verify'));
const ForgotPasswordPage = lazy(() => import('src/pages/auth/forgot-password'));
const ResetPasswordPage = lazy(() => import('src/pages/auth/reset-password'));

// ----------------------------------------------------------------------

const login = {
  path: 'login',
  element: (
    <AuthClassicLayout>
      <LoginPage />
    </AuthClassicLayout>
  ),
};

const phone = {
  path: 'phone',
  element: (
    <AuthClassicLayout title="">
      <AuthPhonePage />
    </AuthClassicLayout>
  ),
};

const register = {
  path: 'register',
  element: (
    <OtpGuard>
      <AuthClassicLayout title="">
        <RegisterPage />
      </AuthClassicLayout>
    </OtpGuard>
  ),
};

const verify = {
  path: 'verify',
  element: (
    <OtpGuard>
      <AuthClassicLayout showLogo={false}>
        <VerifyPage />
      </AuthClassicLayout>
    </OtpGuard>
  ),
};

const forgotPassword = {
  path: 'forgot-password',
  element: (
    <AuthClassicLayout showLogo={false}>
      <ForgotPasswordPage />
    </AuthClassicLayout>
  ),
};

const resetPassword = {
  path: 'reset-password',
  element: (
    <OtpGuard>
      <AuthClassicLayout showLogo={false}>
        <ResetPasswordPage />
      </AuthClassicLayout>
    </OtpGuard>
  ),
};

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <GuestGuard>
        <Outlet />
      </GuestGuard>
    ),
    children: [login, phone, register, verify, forgotPassword, resetPassword],
  },
];
